import { render, staticRenderFns } from "./FormTextAreaDisableResize.vue?vue&type=template&id=51c47e4e&"
import script from "./FormTextAreaDisableResize.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaDisableResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports